import React from 'react';
import { ICustomer, ICustomersQueryParams, IQueryResult } from 'gen/ApiClient';
import { IQueryContext } from 'framework/context/IQueryContext';

export const QueryContext = React.createContext<IQueryContext<IQueryResult<ICustomer>, ICustomersQueryParams>>(undefined as any);